import { render, staticRenderFns } from "./ApplicationAdminChangeHistory.vue?vue&type=template&id=fd2f90ce"
import script from "./ApplicationAdminChangeHistory.vue?vue&type=script&lang=js"
export * from "./ApplicationAdminChangeHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports